import { Route, Routes } from 'react-router-dom';
import './App.css';
import { Applicant } from './components/layouts/applicant';
import { ApolloConnection } from './components/shared/apollo-connection';
import MaintenanceMessageProvider from './components/shared/maintenance-message';
import { Root } from './components/layouts/root';
import { RequireAuth } from './components/shared/require-auth';
import { AuthLanding } from './components/shared/auth-landing';
import { Helmet } from 'react-helmet';
import { IdleTimer } from './components/shared/idle-timer';
export const App: React.FC = () => {
  const authSection = (
    <RequireAuth redirectPath="/" forceLogin={true}>
      <AuthLanding />
    </RequireAuth>
  );

  const rootSection = <Root />;

  const applicantSection = (
    <RequireAuth redirectPath="/" forceLogin={true}>
      <IdleTimer>
        <Applicant />
      </IdleTimer>
    </RequireAuth>
  );

  return (
    <>
      <Helmet titleTemplate="CVHP: %s" />
      <ApolloConnection>
        <MaintenanceMessageProvider>
          <Routes>
            <Route path="*" element={rootSection} />
            <Route path="/auth-redirect" element={authSection} />
            <Route path="/applicant/*" element={applicantSection} />
          </Routes>
        </MaintenanceMessageProvider>
      </ApolloConnection>
    </>
  );
};
